<template>
  <div class="root">
    <div class="leftbox">
      <div class="subtitle">DIỆN</div>
      <div class="title">Ra sao?</div>
    </div>
    <div class="rightbox">
      <swiper class="swiper" :options="swiperOption">
        <swiper-slide class="slide">
          <img src="@/assets/fold5/1.jpg" class="slide-img" />
        </swiper-slide>
        <swiper-slide class="slide">
          <img src="@/assets/fold5/2.jpg" class="slide-img" />
        </swiper-slide>
        <swiper-slide class="slide">
          <img src="@/assets/fold5/3.jpg" class="slide-img" />
        </swiper-slide>
        <swiper-slide class="slide">
          <img src="@/assets/fold5/4.jpg" class="slide-img" />
        </swiper-slide>
        <swiper-slide class="slide">
          <img src="@/assets/fold5/5.jpg" class="slide-img" />
        </swiper-slide>

        <div
          class="swiper-pagination swiper-pagination-custom"
          slot="pagination"
        ></div>
        <!-- <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div> -->
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: "fold5",
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 16,
        loop: true,
        autoplay: {
          delay: 3500,
          disableOnInteraction: true,
        },
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
};
</script>
<style lang="scss" scoped>
.root {
  .subtitle {
    font-family: "SVN-Gotham", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 16px;
    /* identical to box height, or 100% */

    text-align: center;
    letter-spacing: 0.5em;

    color: #000000;
  }
  .title {
    font-family: "Rollgates Fabulous", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 48px;
    line-height: 54px;
    /* identical to box height, or 112% */

    text-align: center;

    color: #000000;
    margin-bottom: 32px;
  }
  .slide {
    width: 300px;
    .slide-img {
      width: 300px;
    }
  }
  .swiper-pagination-custom {
    font-family: "Rollgates Fabulous", sans-serif;
    position: relative;
    padding-top: 32px;
    padding-bottom: 32px;
  }
}
@media (min-width: 1024px) {
  .root {
    overflow: hidden;
    box-sizing: border-box;
    display: grid;
    grid-template-columns: 360px calc(100vw - 360px);
    .leftbox {
      padding-left: 60px;
      padding-right: 60px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      .subtitle {
        text-align: left;
        margin-bottom: 28px;
      }
      .title {
        text-align: left;
      }
    }
    .rightbox {
    }
  }
}
</style>